import { FC } from 'react';
import { Domicilio } from '../../model/Domicilio';
import { PROVINCE } from '../../constants/data';
import { ResumenBase } from './ResumenBase';

type Props = {
  getAddress: () => Domicilio | undefined;
};

export const DireccionResumen: FC<Props> = ({ getAddress }) => {
  const address = getAddress();
  if (!address) return <></>;

  return (
    <ResumenBase>
      {' '}
      El domicilio de envío es <b aria-label={getAddressAccesible(address)}>{getAddressString(address)}</b>.
    </ResumenBase>
  );
};

function checkNotEmpty(str?: string | undefined) {
  return str != null && typeof str === 'string' && str.trim().length > 0;
}

export function getAddressString(address?: Domicilio) {
  let provincia;
  if (!address) return '';

  if (address.provinceId) {
    switch (address.provinceId.toString()) {
      case PROVINCE.CIUDAD_BUENOS_AIRES.toString(): {
        provincia = 'CABA';
        break;
      }
      case PROVINCE.PROVINCIA_DE_BUENOS_AIRES.toString(): {
        provincia = 'Buenos Aires';
        break;
      }
      default: {
      }
    }
  }
  const hasFlat = checkNotEmpty(address.flat);

  //Separador entre departamento y el texto anterior.
  let doorSeparator = '';
  if (checkNotEmpty(address.door)) {
    if (hasFlat) doorSeparator = '°';
    else if (address.streetNumber != null) doorSeparator = ' ';
  }

  const textBeforeDistrict = checkNotEmpty(address.streetName) || address.streetNumber != null || hasFlat || checkNotEmpty(address.door);
  const districtSeparator = checkNotEmpty(address.districtName) && textBeforeDistrict;

  const textBeforeProvince = textBeforeDistrict || checkNotEmpty(address.districtName);
  const provinceSeparator = checkNotEmpty(provincia) && textBeforeProvince;

  const addressStr = `${address.streetName ?? ''} ${address.streetNumber ?? ''}${hasFlat ? ' ' : ''}${address.flat ?? ''}${doorSeparator}${
    address.door ?? ''
  }${districtSeparator ? ', ' : ''}${address.districtName ?? ''}${provinceSeparator ? ',' : ''} ${provincia ?? ''} `;

  return addressStr?.toUpperCase();
}

/**
 * Se formatea la dirección para el lector de pantallas.
 */
function getAddressAccesible(address?: Domicilio) {
  let provincia = '';
  if (!address) return '';

  if (address.provinceId) {
    switch (address.provinceId.toString()) {
      case PROVINCE.CIUDAD_BUENOS_AIRES.toString(): {
        provincia = 'Ciudad Autónoma de Buenos Aires';
        break;
      }
      case PROVINCE.PROVINCIA_DE_BUENOS_AIRES.toString(): {
        provincia = 'Provincia de Buenos Aires';
        break;
      }
      default: {
      }
    }
  }

  const flat = address.flat ? `Piso: ${address.flat},` : '';
  const door = address.door ? `Departamento: ${address.door},` : '';
  const district = address.districtName ? `Localidad: ${address.districtName},` : '';

  const addressStr = `
    ${address.streetName ?? ''}
    ${address.streetNumber ?? ''} ${address.streetNumber ? ',' : ''}
    ${flat}
    ${door}
    ${district}
    ${provincia}`;

  return addressStr;
}
